const fillServerErrors = require('../../../common/components/servererrorfiller');
const _ = require('lodash');
const atmCompetitionEvents = require('./atmmapper/competition');

const API_MAP = {
    COMPETITION_BY_SUPPLIER: 'CompetitionBySupplier',
    ACQUISITION: 'Acquisition',
    NEW_CUSTOMERS_ONLY: 'NewCustomersOnly'
};


function competitionDirective(
        $state,
        $rootScope,
        ageCalculatorService,
        settingsService,
        shopperService,
        shopperMarketingService,
        breakpointsService,
        globalHeaderPanelService,
        currentUserService,
        competitionService,
        $stateParams,
        $sce,
        $timeout,
        signupService,
        atm,
        googleCaptchaV3Service,
        passwordValidationService
    ) {

    return {
        restrict: 'E',
        scope: {},
        template: require('./competition-template.html').trim(),
        link(scope, elem) {
            scope.comp = {};

            scope.enableUniqueCode = false; // TODO: not in use - probably can be remove

            // scope vm is obect for UI, because ng-if will create a child scope
            // scope.competition is the HTML form reference will be added by Angular
            scope.vm = {
                showForm: false,
                showEnterButton: false,
                isNewRegisteredUser: false,
                htmlTooltip: undefined,
                imageUrl: undefined,
                loading: false,
                user: currentUserService.currentUser,
                selectTnc: false,
                selectPartnerTnc: false,
                selectPrivacy: false,
                selectShareCustomerDetails: false,
                isEligible: false,
                disableSubmitButton: false,
                enableUniqueCode: false,
                requirePassword: false,
                isAddingNewAddress: { mode: true },
                addressStoreLocatorSearch: {},
                signupValidationMessage: null,
                showLogin: false,
                passwordPatternError: passwordValidationService.passwordPatternError,
                passwordPattern: passwordValidationService.getPattern(), // if this call fail, this directive will not run
                passwordHinthtmlTooltip: $sce.trustAsHtml(passwordValidationService.passwordHint),
                competitionValidationErrors: {},
                showReCaptcha: false,
                compSubmitSuccess: false,
                enterButtonText: 'Enter Now'
            };

            scope.vm.passwordTooltip = $sce.trustAsHtml(`
                <p class="tooltip_message">
                    <span class="title--small tooltip_title title">
                        <span class="icon--remove visible-xs"></span>
                        ${passwordValidationService.passwordHintTitle}
                    </span>
                    ${passwordValidationService.passwordHintMessage}
                </p>
            `);

            // internal variables. Will be overwrite on init
            let userStatusId = '';
            let shopperId = '';
            let noAddressResult = false;
            let disableSubmission = false;
            let scrollToViewTimer = null;
            let googleCaptchaError = null;
            let isSmallFormat = breakpointsService.isInSmallFormat;
            // ** currentUserService.currentUser.isGuest default is true
            // a guest with a registered user email is a guest AND a registered user!
            // on init we overwrite isExistingUser by calling /CheckEmail API to determine user is registered or not
            // Therefore do not use scope.vm.user.isGuest for UI display logic
            let isExistingUser = !currentUserService.currentUser.isGuest;
            let lastFocusedField = ''; // for tracking

            const EVENTS = {
                DISPLAY_NEWSLETTER_SUBSCRIPTION: 'displayNewsletterSubscription'
            };

            const minLocationSearchLength = 2;

            function isUserLoggedIn() {
                // NOTE: guest user in session is also a logged-in user, hence there will be id > 0
                return !!(scope.vm.user.id && scope.vm.user.email);
            }

            function getImage(src) {
                const url = src || '';
                const path = url.split('/').slice(0, -1).join('/') + '/';
                const name = url.split('/').slice(-1).join().split('.').shift();
                const ext = url.split('.').pop();
                const size = isSmallFormat ? '-small' : '-large';

                return path + name + size + '.' + ext;
            }

            function removeDomElement(domNode) {
                if (!domNode || !domNode instanceof HTMLElement) {
                    return;
                }

                if (typeof domNode.remove === 'function') {
                    domNode.remove();
                    return;
                }

                const parentNode = domNode.parentNode;

                if (parentNode && typeof parentNode.removeChild === 'function') {
                    domNode.parentNode.removeChild(domNode);
                }
            }

            function updateConfirmationImage() {
                // confirmation image is from BWS Site setting, author provide the html
                // therefore we can't do this in angular template like the hero image
                const container = document.querySelector('.competition--confirmation');
                const confirmationImage = container
                    ? container.querySelector('.img-confirmation')
                    : null;

                if (!confirmationImage) {
                    return;
                }

                const imageSrc = confirmationImage.getAttribute('src');

                if (imageSrc) {
                    confirmationImage.setAttribute('src', getImage(imageSrc));
                }
            }

            // manipulate HTMl from BWS site management
            // will do nothing if the following element not exisits
            function updateConfirmationMessage() {
                const existingUserContent = document.getElementById('com-existingUser');
                const newUserContent = document.getElementById('com-newUser');

                if (scope.vm.isNewRegisteredUser) {
                    removeDomElement(existingUserContent);
                } else {
                    removeDomElement(newUserContent);
                }
            }

            function scrollToView(elementSelector) {
                window.clearTimeout(scrollToViewTimer);

                const selector = elementSelector || '.js-competition-form';

                scrollToViewTimer = window.setTimeout(() => {
                    const competitionForm = document.querySelector(selector);

                    if (!competitionForm) {
                        return;
                    }

                    const headerOffset = breakpointsService.getScrollOffset();
                    const scrollTopPx = (competitionForm.getBoundingClientRect().top + window.scrollY) - headerOffset;

                    window.scrollTo({
                        top: scrollTopPx,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 300);
            }

            // clear previouse recaptcha error state
            function resetRecaptchaError() {
                if (scope.vm.competitionValidationErrors && scope.vm.competitionValidationErrors.GoogleReCaptchaResponse) {
                    delete scope.vm.competitionValidationErrors.GoogleReCaptchaResponse;
                }
            }

            //Competition user details request mapping object.
            function buildUserDetails() {
                let selectTnc = scope.vm.selectTnc;
                let selectPrivacy = scope.vm.selectPrivacy;
                let selectNewsLetter = selectTnc && selectPrivacy;

                if (scope.vm.user) {
                    if (typeof scope.vm.user.TermsAndConditions === 'boolean') {
                        selectTnc = scope.vm.user.TermsAndConditions;
                    }
                    if (typeof scope.vm.user.PrivacyPolicy === 'boolean') {
                        selectPrivacy = scope.vm.user.TermsAnPrivacyPolicydConditions;
                    }
                    if (typeof scope.vm.user.Newsletter === 'boolean') {
                        selectNewsLetter = scope.vm.user.Newsletter;
                    }
                }

                // if not require DisplayThirdPartyConsentCheckbox set selectShareCustomerDetails to null
                if (!scope.comp.DisplayThirdPartyConsentCheckbox) {
                    scope.vm.selectShareCustomerDetails = null;
                }

                scope.userDetails = {
                    FirstName: scope.vm.user ? scope.vm.user.firstName : null,
                    LastName: scope.vm.user ? scope.vm.user.lastName : null,
                    Email: scope.vm.user ? scope.vm.user.email : null,
                    Password: null,
                    DateOfBirth: scope.vm.user ? scope.vm.user.dateOfBirth : null,
                    ContactNumber: scope.vm.user ? scope.vm.user.phone : null,
                    CompetitionUrlCode: $stateParams.page,
                    UniqueCode: null,
                    FreeText: null,
                    TermsAndConditions: selectTnc,
                    PrivacyPolicy: selectPrivacy,
                    Newsletter: selectNewsLetter,
                    ShareCustomerDetails: null,
                    ThirdPartySharingConsent: scope.vm.selectShareCustomerDetails
                };
            }

            function checkPartnerEligibility() {
                const errorMessage = competitionService.getEligibleErrorMessage({
                    statusId: userStatusId,
                    disallowRegisteredUser: (isExistingUser && !scope.comp.allowRegisteredUser)
                });

                if (errorMessage) {
                    const fieldErrors = {
                        Email: [errorMessage]
                    };

                    if (scope.competition) {
                        fillServerErrors.fillForm(scope.competition, fieldErrors, scope);
                        scope.vm.competitionValidationErrors = fieldErrors;
                    }
                    return false;
                }

                return true;
            }

            function getShopperDetailsAsync(isGuest) {
                if (isGuest) {
                    return Promise.resolve({
                        Success: true
                    });
                }

                return shopperService
                    .getCurrentShopperDetails()
                    .then(() => {
                        scope.vm.user = currentUserService.currentUser;
                        return shopperService.getCurrentShopperPreferences();
                    })
                    .then((response) => {
                        scope.userHasOptIn = response.preferences.OptInEmail;
                    });
            }

            function subscribeToNewsLetter(checked) {
                return {
                    OptInOnlineMedia: checked,
                    OptInTelephone: checked,
                    OptInMail: checked,
                    OptInInPerson: checked,
                    OptInEmail: checked,
                    OptInPushAlerts: checked,
                    OptInSms: checked,
                    OptInMms: checked,
                    OptInFreeSamples: checked,
                    OptInFavourites: checked,
                    OptInFavouritesSms: checked
                };
            }

            function validateMarketingInfo() {
                let ret = false;
                const currentAutoCompleteValue = scope.competition.autoComplete.$viewValue;

                if (!currentAutoCompleteValue || currentAutoCompleteValue.length < minLocationSearchLength) {
                    return ret;
                }

                // tell shop-locator-search to do validation
                scope.$broadcast('validateLocation', currentAutoCompleteValue);

                if (
                    scope.competition.autoComplete.$valid &&
                    scope.vm.addressStoreLocatorSearch.suburb &&
                    scope.vm.addressStoreLocatorSearch.state &&
                    scope.vm.addressStoreLocatorSearch.postcode
                ) {
                    ret = noAddressResult === false;
                }

                return ret;
            }

            function saveCompetitionAsync() {
                return googleCaptchaV3Service
                        .getToken({ action: googleCaptchaV3Service.ReCaptchaActions.Signup })
                        .then((token) => {
                            // create a data object instead of populate scope.userDetails
                            const data = _.assign(
                                {},
                                scope.userDetails,
                                {
                                    GoogleReCaptchaResponse: token || '',
                                    GoogleReCaptchaVersion: 'v3'
                                }
                            );

                            googleCaptchaError = null;

                            return competitionService.submit(data);
                        })
                        .catch((error) => {
                            // this is google captcha script error
                            // return the error for next 'then' to do other UI logic, otherwise UI will looks like hang
                            googleCaptchaError = error;
                            return error;
                        });
            }

            function signUpUserAsync() {
                const isSubscribeNewsLetter = scope.vm.selectTnc && scope.vm.selectPrivacy;
                // add extra data to scope.userDetails
                //Transform dto to match expected object for the signup service
                _.assign(
                    scope.userDetails,
                    subscribeToNewsLetter(isSubscribeNewsLetter),
                    {
                        EmailAddress: scope.userDetails.Email,
                        MobilePhone: scope.userDetails.ContactNumber,
                        TypeOfDeliveryMethod: 'DecideLater',
                        CampaignSource: scope.comp.CampaignSource || $stateParams.page || '',
                        TermsAndConditions: scope.vm.selectTnc,
                        PrivacyPolicy: scope.vm.selectPrivacy,
                        Newsletter: isSubscribeNewsLetter,
                        ShareCustomerDetails: null,
                        ThirdPartySharingConsent: scope.vm.selectShareCustomerDetails
                    }
                );

                // only signup new user
                if (isExistingUser) {
                    return Promise.resolve({
                        Success: true
                    });
                }

                return googleCaptchaV3Service
                    .getToken({ action: googleCaptchaV3Service.ReCaptchaActions.Signup })
                    .then((token) => {
                        const reCaptchaConfig = {
                            token: token || '',
                            action: googleCaptchaV3Service.ReCaptchaActions.Signup,
                            version: 'v3'
                        };

                        googleCaptchaError = null;

                        return signupService.signup(scope.userDetails, reCaptchaConfig);
                    })
                    .catch((error) => {
                        // this is google captcha script error
                        // return the error for next 'then' to do other UI logic, otherwise UI will looks like hang
                        googleCaptchaError = error;
                        return error;
                    });
            }

            function checkExistingUserAsync(email = '') {
                const emailAddress = email || scope.userDetails.Email;

                if (!emailAddress) {
                    disableSubmission = false;
                    scope.vm.disableSubmitButton = false;

                    return Promise.resolve({
                        Success: true,
                        IsRegistered: false
                    });
                }

                disableSubmission = true;

                resetRecaptchaError();

                return googleCaptchaV3Service
                    .getToken({ action: 'checkemail' })
                    .then((token) => {
                        const data = {
                            Email: emailAddress,
                            RecaptchaToken: token || ''
                        };

                        return shopperService.checkEmail(data);
                    })
                    .then((res) => {
                        if (!res.Success) {
                            disableSubmission = false;
                            scope.vm.disableSubmitButton = false;
                            return;
                        }

                        isExistingUser = res.IsRegistered;
                        scope.vm.requirePassword = !res.IsRegistered;
                        shopperId = res.ShopperId || '';
                        userStatusId = res.StatusId || '';

                        // clear previous entered password
                        if (!scope.vm.requirePassword && scope.userDetails.Password) {
                            scope.userDetails.Password = '';
                        }

                        // check if user can participate
                        const isAllowParticipate = checkPartnerEligibility();
                        disableSubmission = !isAllowParticipate;
                        scope.vm.disableSubmitButton = !isAllowParticipate;

                        // Analytics track registered user error
                        if (!isAllowParticipate) {
                            atm.push({
                                    area: $stateParams.page,
                                    formName: scope.comp.CompetitionName || '',
                                    error: 'email exist',
                                    shopperId
                                },
                                atmCompetitionEvents.disallowParticipate
                            );
                        }
                    })
                    .catch(() => {
                        disableSubmission = false;
                        scope.vm.disableSubmitButton = false;
                    });
            }

            function submitCompetition() {
                scope.vm.loading = true;

                scrollToView('.competition--confirmation');

                // check if allow for registered user to participate.
                if (isExistingUser && !scope.comp.allowRegisteredUser) {
                    disableSubmission = true;
                    scope.vm.disableSubmitButton = true;
                    scope.vm.loading = false;
                    return;
                }

                _.assign(
                    scope.userDetails,
                    subscribeToNewsLetter(scope.vm.selectTnc && scope.vm.selectPrivacy),
                    {
                        suburb: scope.vm.addressStoreLocatorSearch.suburb || '',
                        state: scope.vm.addressStoreLocatorSearch.state || '',
                        postcode: scope.vm.addressStoreLocatorSearch.postcode || ''
                    }
                );

                resetRecaptchaError();

                signUpUserAsync()
                    .then((res) => {
                        if (res.Success) {
                            if (!isExistingUser) {
                                scope.vm.isNewRegisteredUser = true;
                            }
                            // reset scope variables
                            if (scope.vm.signupValidationMessage) {
                                scope.vm.signupValidationMessage = null;
                            }

                            return saveCompetitionAsync(res);
                        }

                        scope.vm.signupValidationMessage = res.Message || 'Something went wrong.';

                        if (res.FieldErrors) {
                            scope.vm.competitionValidationErrors = res.FieldErrors;
                            fillServerErrors.fillForm(scope.competition, res.FieldErrors, scope);
                        }
                        // error handling by 'catch'
                        throw res.data || res;
                    })
                    .then((response) => {
                        if (!response.Success) {
                            scope.vm.compSubmitSuccess = false;

                            if (response.FieldErrors) {
                                scope.vm.competitionValidationErrors = response.FieldErrors;
                                fillServerErrors.fillForm(scope.competition, response.FieldErrors, scope);
                            }

                            scope.vm.loading = false;
                            disableSubmission = false;
                            return;
                        }

                        scope.enterySuccess = response;

                        const compData = {
                            hasOptedIn: scope.vm.selectTnc && scope.vm.selectPrivacy,
                            compName: scope.comp.CompetitionName,
                            area: $stateParams.page
                        };

                        // author seems default to have a dot as comfirmation message
                        response.ConfirmationMessage = `${response.ConfirmationMessage}`.trim();
                        response.ConfirmationMessage = response.ConfirmationMessage === '.'
                            ? ''
                            : response.ConfirmationMessage;
                        
                        if (response.ConfirmationMessage) {
                            scope.enterySuccess.ConfirmationMessage = $sce.trustAsHtml(response.ConfirmationMessage);
                        }

                        // only call for registered and already logged-in user
                        // this API only allow for logged-in user
                        // fetch updated shopper details and update localStorage
                        if (isExistingUser && isUserLoggedIn()) {
                            shopperService.getCurrentShopperDetails();
                        }

                        // update DOM after ng-bind-html done
                        $timeout(() => {
                            updateConfirmationImage();
                            updateConfirmationMessage();
                            // show confirmation section
                            scope.vm.compSubmitSuccess = true;
                            scope.vm.loading = false;
                            disableSubmission = false;
                        }, 1000);

                        atm.push(compData, atmCompetitionEvents.success);
                    })
                    .catch((error = {}) => {
                        scope.vm.loading = false;
                        disableSubmission = false;

                        // track edge case error, when fail at API and is not server side validation error
                        const isServerValidationError = !!error.FieldErrors;

                        if (!isServerValidationError) {
                            const isReCaptchaError = !!(googleCaptchaError || (scope.vm.competitionValidationErrors && scope.vm.competitionValidationErrors.GoogleReCaptchaResponse));
                            const errorMessage = error.message || scope.vm.signupValidationMessage;
                            const errorData = `Error message: ${errorMessage}. IsExistingUser: ${isExistingUser}. IsReCaptchaError: ${isReCaptchaError}. User status: ${userStatusId}.`;

                            // reuse 'BWSAUexistingCustomer' event for this tracking
                            atm.push({
                                    area: $stateParams.page,
                                    formName: scope.comp.CompetitionName || '',
                                    error: errorData,
                                    shopperId
                                },
                                atmCompetitionEvents.disallowParticipate
                            );
                        }
                    });
            }

            scope.vm.showCompForm = function () {
                if (!scope.vm.showForm) {
                    scope.vm.showForm = true;
                    scope.vm.showEnterButton = false;
                }

                scrollToView();
            };

            scope.vm.checkEligibility = function () {
                const isEligible = (scope.competition.DateOfBirth.$valid && ageCalculatorService.calculate(scope.userDetails.DateOfBirth) >= 18);
                scope.vm.isEligible = isEligible;
                return isEligible;
            };

            scope.vm.enter = function () {
                // during other aysnc calls, disableSubmission is true
                if (disableSubmission) {
                     return false;
                }

                fillServerErrors.clearForm(scope.competition, scope);

                if (
                    !scope.vm.checkEligibility() ||
                    !scope.competition.$valid ||
                    !validateMarketingInfo()
                ) {
                    return false;
                }

                disableSubmission = true;

                scope.vm.signupValidationMessage = null;

                submitCompetition();
            };

            scope.vm.signIn = ($event) => {
                $event.preventDefault();

                if (breakpointsService.isInSmallFormat) {
                    $state.go('shop.authentication.login');
                    return;
                }

                globalHeaderPanelService.openPanel(globalHeaderPanelService.panels.login);
            };

            scope.vm.checkUserId = () => {
                if (scope.competition.Email.$invalid) {
                    return;
                }
                checkExistingUserAsync();
            };

            scope.$on('login:success', function (e, loginResult) {
                if (loginResult.LoginResult === 'Success') {
                    getShopperDetailsAsync();
                }
            });

            scope.$on('window:resize', function () {
                scope.$apply(function () {
                    isSmallFormat = breakpointsService.isSmallFormat();
                    scope.vm.imageUrl = getImage(scope.comp.Image);

                    updateConfirmationImage();
                });
            });

            scope.$on('noResults', function(event, data) {
                noAddressResult = data;
            });

            function getPlainResponse(res) {
                // remove Restangular stuff from response
                return res && typeof res.plain === 'function'
                        ? res.plain()
                        : res;
            }

            function convertCompetitionSettings(res = {}) {
                // map competition API repsonse to UI data signature
                // Due to backward compatibility requirement. 'IntendedParticipatingCustomers' and 'TypeOfCampaign' could be null or 'None'
                // if author failed to provide proper settings assume:
                // - all campaign type allow registered user unless IntendedParticipatingCustomers === 'NewCustomersOnly'
                // - submitButtonText default as 'Enter Now' unless TypeOfCampaign === 'Acquisition'
                const campaignType = res.TypeOfCampaign;
                const allowRegisteredUser = res.IntendedParticipatingCustomers !== API_MAP.NEW_CUSTOMERS_ONLY;
                let submitButtonText = res.submitButtonText || 'Enter Now';

                if (campaignType === API_MAP.ACQUISITION) {
                    submitButtonText = 'Join Now';
                }

                scope.vm.enterButtonText = submitButtonText;

                return Object.assign({}, res,
                    {
                        allowRegisteredUser,
                        submitButtonText
                    }
                );
            }

            function init() {
                scope.vm.loading = true;

                competitionService
                    .getCompetitionDetails($stateParams.page)
                    .then(function (res) {
                        const response = getPlainResponse(res) || {};

                        scope.comp = convertCompetitionSettings(response);

                        // tooltip html from competition
                        scope.vm.htmlTooltip = $sce.trustAsHtml(response.TooltipText);
                        scope.vm.imageUrl = getImage(scope.comp.Image);

                        return getShopperDetailsAsync(currentUserService.currentUser.isGuest);
                    })
                    .then(() => {
                        buildUserDetails();

                        return checkExistingUserAsync(scope.vm.user.email);
                    })
                    .then(() => {
                        if (!checkPartnerEligibility()) {
                            scope.vm.disableSubmitButton = true;
                            scope.competition.Email.$setTouched();
                        }

                        scope.vm.showLogin = scope.comp.allowRegisteredUser && !isExistingUser;

                        // show form when not expired(comp.Success)
                        if (scope.comp.Success) {
                            // overwrite if competition is manage by external supplier
                            if (scope.comp.TypeOfCampaign === API_MAP.COMPETITION_BY_SUPPLIER) {
                                scope.vm.showEnterButton = false;
                            } else {
                                // show 'enter now' button or show the form
                                if (scope.comp.HideForm) {
                                    scope.vm.showEnterButton = true;
                                } else {
                                    scope.vm.showEnterButton = false;
                                    scope.vm.showCompForm();
                                }
                            }
                        }

                        scope.vm.loading = false;
                    })
                    .catch(() => {
                        scope.vm.loading = false;
                    });

                settingsService
                    .getSettingValue('GoogleReCaptcha', 'EnableGoogleReCaptcha')
                    .then(function (res) {
                        const response = getPlainResponse(res);
                        scope.vm.showReCaptcha = response;

                        if (scope.vm.showReCaptcha) {
                            // inject google script into the page
                            googleCaptchaV3Service.load();
                        }
                    });

                shopperMarketingService
                    .getShopperMarketingInfo()
                    .then(function(res = {}) {
                        if (res.Success) {
                            scope.vm.locationData = {
                                suburb: res.Suburb || '',
                                state: res.State || '',
                                postcode: res.PostCode || ''
                            };
                        }
                    });
            }

            // ------------------- Analytics --------------------- //

            // check when the form become dirty for the first time
            // send an event to analytics service
            const atmFormWatcher = scope.$watch('userDetails', () => {
                if (scope.competition && scope.competition.$dirty) {
                    competitionService.competitionStart();
                    atmFormWatcher(); // remove the watcher
                }
            }, true);

            // get the last dirty field and save it for atmRegistrationAbandoned
            elem.find('.input').on('focus', (data) => {
                if (data && data.currentTarget && data.currentTarget.id) {
                    lastFocusedField = data.currentTarget.id;
                }
            });

            // hide footer newsletter subscription
            $rootScope.$emit(EVENTS.DISPLAY_NEWSLETTER_SUBSCRIPTION, false);

            //  check when this directive is destroyed and fire an event to analytics
            scope.$on('$destroy', () => {
                $rootScope.$emit(EVENTS.DISPLAY_NEWSLETTER_SUBSCRIPTION, true);

                if (!scope.vm.compSubmitSuccess) {
                    competitionService.competitionAbandoned(lastFocusedField);
                }
            });

            init();
        }
    };
}

// closure
(function() {
    function selectCampaignType(targetValue) {
        const input = document.querySelector('input[value="' + targetValue + '"]');
        if (input) {
            input.checked = true;
        }
    }
    
    function checkSelectedCampaign() {
        const input = document.querySelector('input[name = "TypeOfCampaign"]:checked');
        return input && input.value !== 'None'
            ? input.value
            : '';
    }
    
    function init() {
        const selectedCampaign = checkSelectedCampaign();
        if (!selectedCampaign) {
            selectCampaignType('CompetitionByBWS');
        }
    }
    
    // start here
    init();
}());


module.exports = competitionDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/competition-directive.js
 **/